import {InforumDates, InforumDatesTracks} from '../Dates';
import '../Main.css'
import {Patreons, PatreonsTracks} from "../Patreons";
import { SortedCommission, SortedCommissionHead } from '../Tracks';

export function Track1_CRC(props: any) {
    
    const cor_pro = [
        "Daniel Corujo, Universidade de Aveiro",
        "João Vilela, Universidade do Porto"
    ]

    const co_pro = [
        "Amaro Sousa, Universidade de Aveiro",
        "Augusto Casaca, INESC-ID",
        "Leonel Santos leonel.santos@ipleiria.pt",
        "Edmundo Monteiro, Universidade de Coimbra",
        "Jorge Sá Silva, Universidade de Coimbra",
        "José Legatheaux Martins, Universidade Nova de Lisboa",
        "Manuel Ricardo, Universidade do Porto",
        "Marilia Curado, Universidade de Coimbra",
        "Noelia Correia, Universidade do Algarve",
        "Paulo Pedreiras, Universidade de Aveiro",
        "Pedro Sousa, Universidade do Minho (CENTRO ALGORITMI)",
        "Rui Campos, INESC TEC",
        "Sérgio Crisóstomo, Universidade do Porto",
        "Susana Sargento, Universidade de Aveiro",
        "Solange Rito Lima, Universidade do Minho",
        "Vasco Pedro, Universidade de Évora",
        "Vasco Pereira, Universidade de Coimbra"]

    return <>
        <div className="Accommodation">

            <div className='Tracks'>
                <div className='TracksOne'>

                    <h1>Comunicações e Redes de Computadores (CRC)</h1>

                    <p>
                        As capacidades de rede e computação evidenciadas pelo 5G, nas suas várias releases, têm-se
                        revelado muito promissoras para uma pletora de aplicações e cenários. Aspetos como a
                        digitalização têm impulsionado diversas áreas verticais, permitindo a concretização de aspetos
                        tais como a Industria4.0. Permitiu também pela primeira vez ver serem aplicadas inovações e
                        novos desenvolvimentos em diversas áreas, não só as focadas no seio das telecomunicações, mas
                        também em muitas outras capacidades complementares e de suporte, como é o caso da computação,
                        automação, inteligência artificial, etc.
                        Um dos aspetos resultantes desta congregação, evidenciou também que existe um caminho a
                        percorrer para se poder atingir a harmonização plena dessas diferentes valências. Assim,
                        vislumbra-se que as operações de redes e comunicações futuras (nomeadamente as do âmbito do
                        Beyond-5G e do 6G), requerem esforços adicionais na evolução quer de cada tema individual, quer
                        no desenvolvimento de mecanismos de integração e cooperação entre elas. Adicionalmente, para
                        consubstanciar e acreditar todos estes esforços, é necessário também integrar neste processo os
                        consumidores do resultado final destas tecnologias, que poderão ir desde diferentes tipos de
                        verticais da indústria, a outros setores e entidades setoriais.
                        Neste sentido, a CRC ambiciona capturar evidências, inovações, trabalhos aplicados, trabalhos em
                        desenvolvimento, modelos, entre outras manifestações destas iniciativas, com vista à
                        disseminação das novas tecnologias de comunicação e redes.
                    </p>

                    <h2>Lista de tópicos</h2>

                    <ul>
                        <li>
                            Novas arquiteturas e paradigmas de comunicações e redes de computadores
                        </li>
                        <li>
                            Redes e Funções de Rede virtualizadas
                        </li>
                        <li>
                            Ambientes cloud no suporte das comunicações e redes
                        </li>
                        <li>
                            Mobile Edge Computing
                        </li>
                        <li>
                            Soluções para comunicações em larga escala
                        </li>
                        <li>
                            Integração de novas tecnologias de comunicações em ambientes de legado
                        </li>
                        <li>
                            Protocolos de Comunicação e de Redes
                        </li>
                        <li>
                            Avanços sobre redes de acesso móveis, sem-fios, oticas e infra-estrutura
                        </li>
                        <li>
                            Redes de teste, demonstradores e pilotos inovadores de comunicações
                        </li>
                        <li>
                            Avaliação de desempenho de novas arquiteturas e protocolos
                        </li>
                        <li>
                            Novos mecanismos para resiliência, fiabilidade, robustez
                        </li>
                        <li>
                            Redes de sensores sem fios, em malha, ad-hoc e veiculares
                        </li>
                        <li>
                            Redes centradas na informação
                        </li>
                        <li>
                            Eficiência energética em sistemas de comunicação sem fios móveis
                        </li>
                        <li>
                            Redes sociais móveis
                        </li>
                        <li>
                            Gestão de sistemas de comunicação, serviços e aplicações
                        </li>
                        <li>
                            Redes definidas por software
                        </li>
                        <li>
                            Redes tolerantes a atraso
                        </li>
                        <li>
                            Sistemas de comunicação em cidades inteligentes
                        </li>
                        <li>
                            Comunicações máquina-a-máquina
                        </li>
                        <li>
                            Segurança e privacidade em sistemas de comunicação móveis e cloud
                        </li>
                        <li>
                            Utilização de conceitos de Inteligência Artificial em Redes de Comunicações e Computadores
                        </li>
                        <li>
                            Redes do Futuro
                        </li>
                        <li>
                            Redes B5G e 6G
                        </li>
                        <li>
                            Comunicações para a Indústria4.0
                        </li>
                        <li>
                            Elaboração de Infraestruturas de testes e validação com verticais e Indústria4.0
                        </li>
                    </ul>

                </div>

                <div className='TracksTwo'>
                    <div className='InsideTracksTwo'>
                    
                    <div className='Submission'>
                    <h2>Link de submissão</h2>

                    <a href="https://easychair.org/conferences/?conf=inforum2023">https://easychair.org/conferences/?conf=inforum2023</a>

                    </div>
                   
                        <h2>Datas importantes</h2>

                        <InforumDatesTracks></InforumDatesTracks>
                        
                        <h2>Comissão coordenadora</h2>

                        <SortedCommissionHead cord={cor_pro} people={co_pro}></SortedCommissionHead>

                        <h2>Comissão de programa</h2>
                        <SortedCommission cord={cor_pro} people={co_pro}></SortedCommission>
                        
                        <PatreonsTracks></PatreonsTracks>
                        
                    </div>


                </div>
            </div>
        </div>

    </>

}
